import styled from 'styled-components';

export const LoginStyle = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 7;
    justify-content: space-evenly;
    background: rgb(125, 170, 216);
    font-size: 18px;
    font-family: Roboto;
    height: 20%;
    min-height: 500px;
    width: 100%;
    padding: 35px 70px 50px 70px;
    color: white;
    box-shadow: 0 12px 15px 0 rgb(0 0 0 / 24%), 0 17px 50px 0 rgb(0 0 0 / 19%);
    input[type=text], input[type=number], select {
        border-radius: 25px;
        border: none;
        color: #6a6f8c;
        background-color: rgba(255, 255, 255, 0.1);
        font-size: inherit;
        width: 100%;
    }
    select {
        padding: 10px 15px;
    }
    @media (min-width: 525px) {
        width: 525px;
        margin: 0 auto;
    }
`;

export const LoginInput = styled.input`
    padding: 15px 20px;
    ::-webkit-inner-spin-button {
        display: none;
    }
`;

export const LoginButton = styled.button`
    --webkit-appearance: none;
    color: #fff;
    width: 10rem;
    background-color: #5982C9;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 25px;
    padding: 15px 20px;
`;

export const LoadingButton = styled.button`
    --webkit-appearance: none;
    color: #111111;
    width: 10rem;
    background-color: #D3D3D3;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 25px;
    padding: 15px 20px;
`;
export const LoginLabel = styled.label`
    font-size: ${props => props.fontSize ?? props.theme.smallFont};
    margin-bottom: 8px;
    margin-left: 15px;
`;

export const PresentationTypeContainer = styled.div`
    display: flex;
    justify-content: space-around;
    width: 70%;
`;

export const InputContainer = styled.div`
    display: inherit;
    flex-direction: inherit;
    justify-content: flex-start;
    width: 100%;
`;
